import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function BEIAProject() {
  return (
    <div className="art-page">
      <SEO
        title="Biomass Energy Initiative for Africa (BEIA) — TLUD Gasifier Stove Study"
        description="CIRCODU assessed TLUD wood stove performance against traditional charcoal stoves using baseline and follow-up air quality measurements, Kitchen Performance Tests, and stove usage monitors."
        keywords="BEIA, TLUD gasifier, wood stove, household energy, emissions testing, air quality monitoring, fuel consumption, stove usage monitoring, Uganda, clean cooking, carbon offset, CIRCODU, BEIA TLUD study Uganda, TLUD stove performance Uganda, household air quality Uganda, Kitchen Performance Test Uganda, stove usage monitoring Uganda, clean cooking solutions Uganda"
        url="/Biomass-Energy-Initiative-for-Africa-BEIA-TLUD-Gasifier-Stove-Study-Uganda"
        datePublished="2012-05-01"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Biomass Energy Initiative for Africa (BEIA) — TLUD Gasifier Stove
              Study
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              May 01, 2012
            </div>
            <h1 className="art-title">
              Biomass Energy Initiative for Africa (BEIA) — TLUD Gasifier Stove
              Study, Uganda
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                As part of the{" "}
                <strong>Biomass Energy Initiative for Africa (BEIA)</strong>,
                CIRCODU implemented a household-level study examining the{" "}
                <strong>
                  Top Lit Updraft Gasifier (TLUD) wood stove technology
                </strong>{" "}
                in Uganda. The BEIA programme was a multi-country initiative
                exploring the potential of cleaner biomass combustion
                technologies to reduce household air pollution and carbon
                emissions across the African continent.
              </p>
              <p>
                TLUD stoves represent a more advanced class of biomass
                combustion than conventional improved cookstoves. Rather than
                burning biomass directly, TLUD technology gasifies the fuel
                first, producing a cleaner-burning gas that results in
                significantly lower emissions of particulate matter and carbon
                monoxide — two of the most harmful pollutants produced by
                traditional cooking fires. Their potential to deliver meaningful
                air quality improvements made them a compelling subject for
                research in the Ugandan household context.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU conducted baseline and follow-up data collection on
                household air pollution in participating homes, comparing indoor
                air quality under traditional charcoal stove use and TLUD wood
                stove use. Alongside air quality measurement, CIRCODU carried
                out Kitchen Performance Tests to quantify fuel consumption
                differences between the two technologies, and deployed{" "}
                <strong>stove usage monitors (i-buttons)</strong> to track how
                consistently households used the TLUD stoves over time.
              </p>
              <p>
                The combination of air pollution data, fuel consumption
                measurements, and usage monitoring provided a three-dimensional
                picture of the TLUD stove's real-world impact — not just whether
                it performed better in tests, but whether households actually
                used it and whether indoor air quality improved as a result.
              </p>
              <h2 className="art-subheading">Significance</h2>
              <p>
                CIRCODU's work helped establish whether TLUD technology could
                deliver meaningful air quality improvements in Ugandan household
                settings — evidence important for informing both technology
                selection and carbon market methodologies for higher-tier
                cookstove programmes. The study added to the growing body of
                real-world evidence needed to make the case for TLUD stoves as a
                viable, scalable alternative to charcoal combustion in East
                African households.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's clean energy research,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
